module.exports = __webpack_public_path__ + "img/salad_chicken.b52c7c1a.png";